import React from "react";
import Grid from '@mui/material/Grid';
import StartCard from "../../../../gpap-lib/StartCard/StartCard";
import {submission_cards_config } from "../../../../gpap-lib/StartCard/card_config"
import {Typography} from "@mui/material";
import Box from "@mui/material/Box";
import HOW_TO from "../../../../gpap-lib/img/how_to_experiments.png";



const SubmissionMenu =()=>{


    let origin = window.location.origin;

    return(
        <div className="home">
            <h2 id="home_header">Submit your Experiments and Files</h2>
            <hr className = "divider"/>

            <div className="ctas">
                <div className="container">
                    <Grid container justifyContent="center" spacing={2}>
                        <Grid key={0} item lg={4}><StartCard
                              item={submission_cards_config[0]}/></Grid>
                        <Grid key={2} item lg={4}><StartCard
                              item={submission_cards_config[1]}/></Grid>
                        <Grid key={3} item lg={12}>
                            <hr className="yellowDivider"/>
                            <Box p={2}>
                                <Typography variant={"h6"}> What you need to know</Typography>
                                <Box p={1}>
                                    <img src={HOW_TO} style={{maxWidth: "90%"}}/>
                                </Box>
                                <Typography variant={"h6"}> For any doubt, you can find more information on the <a href={origin + "/gpap_doc/experiment_data.html" }>guidelines</a> <br/> or by contacting us at <a href="mailto:help@rd-connect.eu?Subject=RD-Connect" target="_top" style={{color: "orange"}}>help@rd-connect.eu</a> </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </div>
    );
}

export default SubmissionMenu;
